const envVariables = {
	isDeveloperMode: false,
	corsProxy: '', // /.netlify/functions/cors-proxy?url=
	isDeveloperEndPoint: 'http://127.0.0.1:5000',
	isProductionEndPoint: 'https://chat-with-resume.azurewebsites.net',
};

export { envVariables };
